export default __webpack_public_path__ + "static/media/prev-GNSS-Receiver-1.aa8e8246.png";